import React from "react";
import { ThemeProvider } from "@fluentui/react";
import customTheme from "./theme";
import styles from "./AppThemeProvider.module.css";

interface AppThemeProviderProps {
  children: React.ReactNode;
}

const AppThemeProvider: React.FC<AppThemeProviderProps> = ({ children }) => {
  return (
    <ThemeProvider theme={customTheme} className={styles.themeWrapper}>      
        {children}      
    </ThemeProvider>
  );
};

export default AppThemeProvider;